<template>
  <VContainer class="pa-0 fill-height" fluid>
    <!-- Seções -->
    <TitleRP ref="who_we_are" />
    <HomeScreen
      :screenSize="getHeight"
      @more="scrollToContacts"
      @start_free="$router.push('/' + $i18n.locale + '/trial')"
      @saber-mais="$emit('saber-mais')"
    />
    <Advantages />
    <MobilePresent />
    <ReportLakeDescription />
    <WithReportLake ref="advantages" />
    <WithoutReportLake />
    <SubscriptionPlan ref="subscriptions" />
    <FAQS />
    <PreFooter ref="contacts" />

    <!-- Botão flutuante -->
    <Transition name="bounce">
      <VBtn
        v-if="scheduleBtn"
        rounded
        color="warning"
        class="d-none d-lg-block font-weight-bold text-primary position-fixed elevation-10"
        style="z-index: 99; bottom: 24px; right: 24px;"
        @click="$router.push('/' + $i18n.locale + '/trial')"
      >
        <div class="d-none d-lg-block">
          {{ $t('HOME.btn_gratis') }}!
        </div>

        <div class="d-md-none">
          <VRow>
            <VCol cols="12" class="ma-0 pa-0"></VCol>
            <VCol cols="12" class="ma-0 pa-0">
              <small>{{ $t('HOME.btn_gratis') }}</small>
            </VCol>
          </VRow>
        </div>
      </VBtn>
    </Transition>
  </VContainer>
</template>

<script>
import TitleRP from '@/components/Title.vue'
import HomeScreen from '@/components/HomeScreen.vue'
import Advantages from '@/components/Advantages.vue'
import MobilePresent from '@/components/MobilePresent.vue'
import ReportLakeDescription from '@/components/ReportLakeDescription.vue'
import WithReportLake from '@/components/WithReportLake.vue'
import WithoutReportLake from '@/components/WithoutReportLake.vue'
import SubscriptionPlan from '@/components/SubscriptionPlan.vue'
import PreFooter from '@/components/PreFooter.vue'
import FAQS from '@/components/FAQS.vue'

export default {
  name: 'Home',
  components: {
    TitleRP,
    HomeScreen,
    Advantages,
    MobilePresent,
    ReportLakeDescription,
    WithReportLake,
    WithoutReportLake,
    SubscriptionPlan,
    PreFooter,
    FAQS
  },
  props: {
    menuTab: String
  },
  data() {
    return {
      window: { width: 0, height: 0 },
      scheduleBtn: true
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
    this.handleResize()
  },
  mounted() {
    if (this.$route.hash !== undefined) {
      if (this.$route.hash === '') {
        window.scrollTo(0, 0)
        return
      }
      this.$emit('menu-tab-change', this.$route.hash.split('#')[1])
      this.scrollTo(this.$route.hash.split('#')[1])
    }
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    menuTab(v) {
      this.scrollTo(v)
    }
  },
  computed: {
    getHeight() {
      return this.window.height
    }
  },
  methods: {
    handleScroll() {
      const limit = document.body.offsetHeight - window.innerHeight
      this.scheduleBtn = !((window.scrollY + 10) >= limit)
    },
    async scrollTo(v) {
      if (v === 'advantages') this.$refs.advantages?.$el?.scrollIntoView({ behavior: 'smooth' })
      if (v === 'contacts') this.$refs.contacts?.$el?.scrollIntoView({ behavior: 'smooth' })
      if (v === 'subscriptions') this.$refs.subscriptions?.$el?.scrollIntoView({ behavior: 'smooth' })
      if (v === 'who_we_are') this.$refs.who_we_are?.$el?.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToContacts() {
      this.$refs.contacts?.$el?.scrollIntoView({ behavior: 'smooth' })
    },
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  }
}
</script>
